import { handleActions } from 'redux-actions';
import { receivedSystemStatuses } from '../api/actions';
export const defaultState = {
  systemConfig: [],
  isCommited: true,
  systemFilters: {},
  dataIsFetched: false,
  systemStatuses: [],
};

export default handleActions(
  {
    // [receiveSystem]: (state, action) => {
    //   return {
    //     ...state,
    //     systemConfig: action.payload,
    //   };
    // },
    // [setSystemFilters]: (state, action) => ({
    //   ...state,
    //   systemFilters: action.payload,
    // }),
    [receivedSystemStatuses]: (state, action) => {
      const systems = action.payload;
      return {
        ...state,
        systemStatuses: action.payload,
      }
    },
    // [receivedSystemUpdate]: (state, action) => {
    //   const systems = action.payload;
    //   console.log('Received system update in reducer:', systems);
    //   return {
    //     ...state,
    //     systemStatuses: action.payload,
    //   }
    // },
  },
  defaultState
);
